export const Bindings = {
	// Providers
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	LeaguesApiProvider: Symbol("LeaguesApiProvider"),
	PredictionApiProvider: Symbol("PredictionApiProvider"),
	CrunchApiProvider: Symbol("CrunchApiProvider"),
	CouponApiProvider: Symbol("CouponApiProvider"),
	PromptApiProvider: Symbol("PromptApiProvider"),
	RankingsApiProvider: Symbol("RankingsApiProvider"),
	SharingApiProvider: Symbol("SharingApiProvider"),

	// Controllers
	AuthController: Symbol("AuthController"),
	MyAccountController: Symbol("MyAccountController"),
	HOCMainController: Symbol("HOCMainController"),
	ModalController: Symbol("ModalController"),
	HelpController: Symbol("HelpController"),
	MyLeaguesController: Symbol("MyLeaguesController"),
	FormLeagueCreateController: Symbol("FormLeagueCreateController"),
	InviteLeagueController: Symbol("InviteLeagueController"),
	ShareControllerController: Symbol("ShareControllerController"),
	LeaguesJoinController: Symbol("LeaguesJoinController"),
	JoinLeaguesListItemController: Symbol("JoinLeaguesListItemController"),
	PicksController: Symbol("PicksController"),
	PickItemController: Symbol("PickItemController"),
	PickStickyBarController: Symbol("PickStickyBarController"),
	CrunchController: Symbol("CrunchController"),
	GameBarController: Symbol("GameBarController"),
	StatsController: Symbol("StatsController"),
	LeaderboardPageController: Symbol("LeaderboardPageController"),
	LeagueLadderController: Symbol("LeagueLadderController"),
	ViewLeagueOutletController: Symbol("ViewLeagueOutletController"),
	LeagueAboutController: Symbol("LeagueAboutController"),
	LeagueManageController: Symbol("LeagueManageController"),
	FormLeagueUpdateController: Symbol("FormLeagueUpdateController"),
	ManageTableController: Symbol("ManageTableController"),
	ModalTutorialController: Symbol("ModalTutorialController"),
	SliderScreenController: Symbol("SliderScreenController"),
	ProfileController: Symbol("ProfileController"),
	PredictionsShareModalController: Symbol("PredictionsShareModalController"),
	InvitePageController: Symbol("InvitePageController"),
	PrizesController: Symbol("PrizesController"),
	ContactUsController: Symbol("ContactUsController"),
	HelpListController: Symbol("HelpListController"),

	// Stores
	ModalsStore: Symbol("ModalsStore"),
	UserStore: Symbol("UserStore"),
	CountriesStore: Symbol("CountriesStore"),
	RoundsStore: Symbol("RoundsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	StaticStore: Symbol("StaticStore"),
	LeaguesStore: Symbol("LeaguesStore"),
	PredictionsStore: Symbol("PredictionsStore"),
	CrunchStore: Symbol("CrunchStore"),
	RankingsStore: Symbol("RankingsStore"),
	CouponModalController: Symbol("CouponModalController"),
	CouponStore: Symbol("CouponStore"),
	SubHeaderController: Symbol("SubHeaderController"),
	MobileMenuController: Symbol("MobileMenuController"),
	PromoBannerController: Symbol("PromoBannerController"),
	PromoBannerStore: Symbol("PromoBannerStore"),
	StaticContentStore: Symbol("StaticContentStore"),
	LandingController: Symbol("LandingController"),
	StickyBannerController: Symbol("StickyBannerController"),
};
